import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import md5 from 'crypto-js/md5';

class GameHeader extends Component {
  render() {
    const { name, gravatarEmail, score } = this.props;
    const emailHash = md5(gravatarEmail).toString();
    return (
      <div className="game-header">
        <img data-testid="header-profile-picture" className="gravatar-foto" src={ `https://www.gravatar.com/avatar/${emailHash}` } alt="avatar" />
        <p data-testid="header-player-name">{ name }</p>
        <p data-testid="header-score">
          Pontos:
          { score }
        </p>
      </div>
    );
  }
}

GameHeader.propTypes = {
  name: PropTypes.string.isRequired,
  gravatarEmail: PropTypes.string.isRequired,
  score: PropTypes.number.isRequired,
};

const mapStateToProps = (globalState) => ({ ...globalState.player });

export default connect(mapStateToProps)(GameHeader);
